<template>
  <div class="calendar-key">
    <div class="key-items">
      <b>Key:</b>
      <div class="key-item">
        <i class="fa-duotone fa-hourglass-start module-start"></i>
        <span>Module Start</span>
      </div>
      <div class="key-item">
        <i class="fa-duotone fa-hourglass-end module-completion"></i>
        <span>Module Completion</span>
      </div>
      <div class="key-item">
        <i class="fas fa-circle event"></i>
        <span>Event</span>
      </div>
      <!-- <div class="key-item">
        <i class="fas fa-circle meeting"></i>
        <span>Meeting</span>
      </div> -->
    </div>
  </div>
</template>

<style scoped>
.calendar-key {
  padding: 10px 10px 20px 0;
}

.key-items {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.key-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.event {
  color: var(--kate-type-blue-dark);
}

.meeting {
  color: var(--kate-logo-magenta);
}

.module-start {
  color: var(--kate-success-alt);
}

.module-completion {
  color: var(--kate-warning);
}
</style>

<script>
export default {
  name: 'KCalendarKey',
};
</script>
